import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

import MSBanner from 'app/components/icons/MSBanner.png'
import OutlinedButtons from '../Button/OutlinedButtons'
import { CLOSE } from 'app/constants/button'

const useStyles = makeStyles((theme) => ({
  container: {
    margin: 'auto',
    height: '580px',
    [theme.breakpoints.down(1024)]: {
      overflow: 'auto',
    },
    [theme.breakpoints.up(1024)]: {
      width: '1024px',
      margin: 'auto',
      // display: 'flex',
    },
  },
  banner: {
    [theme.breakpoints.down(1024)]: {
      display: 'none',
    },
    [theme.breakpoints.up(1024)]: {
      width: '50%',
      display: 'block',
      backgroundSize: 'cover !important',
      backgroundPosition: 'center !important',
    },
  },
  content: {
    backgroundColor: 'white',
    overflow: 'auto',
    [theme.breakpoints.down(1024)]: {
      margin: 'auto',
      padding: '3rem',
      borderRadius: '2.4rem',
      width: 'calc(100vw - 50px)',
      height: '100%',
    },
    [theme.breakpoints.up(1024)]: {
      width: '50%',
      padding: '6rem',
      borderTopRightRadius: '2.4rem',
      borderBottomRightRadius: '2.4rem',
    },
  },
}))

const PanelsIllustrationMSG = (props) => {
  const { children, className, isClickBack = false, onBack = () => {} } = props

  const classes = useStyles()

  return (
    <>
      <div className={clsx(className, classes.container)}>
        {isClickBack && (
          <OutlinedButtons
            id="go-back-btn"
            color={CLOSE}
            className="absolute top-[35px]"
            onClick={() => onBack()}
          >
            {'Go Back'}
          </OutlinedButtons>
        )}
        <div className="flex h-full">
          <div className={classes.banner}>
            <img
              className="w-full h-full object-cover rounded-l-24"
              src={MSBanner}
              alt="Banner"
            />
          </div>

          <div className={clsx(classes.content)}>{children}</div>
        </div>
      </div>
    </>
  )
}

PanelsIllustrationMSG.propTypes = {
  onBack: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  isClickBack: PropTypes.bool,
}

export default PanelsIllustrationMSG
